import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Video, ShoppingBag } from "lucide-react";
import Logo from "@/components/Logo";

export default function Login() {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && user) navigate("/feed", { replace: true });
    }, [user, loading, navigate]);

    const handleLogin = () => {
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen bg-[#050505] text-white flex flex-col relative overflow-hidden">
            {/* Ambient background */}
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-[#FF5722]/20 blur-[120px]" />
                <div className="absolute bottom-0 -right-32 w-[500px] h-[500px] rounded-full bg-[#25D366]/10 blur-[130px]" />
            </div>

            <div className="relative z-10 flex-1 flex flex-col items-center justify-center px-6 py-12 max-w-md mx-auto text-left w-full">
                <div className="fade-up w-full">
                    <div className="flex items-center gap-3 mb-8">
                        <Logo size={56} className="shadow-[0_0_35px_rgba(255,87,34,0.5)]" />
                        <span className="font-display text-4xl font-black tracking-tight">VIDMAR</span>
                    </div>

                    <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight leading-[0.95]">
                        Scroll.<br />
                        Voir.<br />
                        <span className="text-[#FF5722]">Commander.</span>
                    </h1>

                    <p className="mt-6 text-lg text-white/70 font-body leading-relaxed">
                        Le marché africain en vidéo. Découvrez des milliers de produits et services près de chez vous, et commandez directement sur WhatsApp.
                    </p>

                    <div className="mt-10 flex flex-col gap-3">
                        <Button
                            data-testid="google-login-btn"
                            onClick={handleLogin}
                            className="w-full h-14 bg-white text-black hover:bg-white/90 font-body font-semibold text-base rounded-full"
                        >
                            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                            </svg>
                            Continuer avec Google
                        </Button>

                        <div className="grid grid-cols-2 gap-3 mt-6">
                            <div className="glass rounded-2xl p-4">
                                <Video className="w-5 h-5 text-[#FF5722]" />
                                <p className="mt-2 text-xs text-white/70 font-body">Vidéos courtes de vrais vendeurs</p>
                            </div>
                            <div className="glass rounded-2xl p-4">
                                <ShoppingBag className="w-5 h-5 text-[#25D366]" />
                                <p className="mt-2 text-xs text-white/70 font-body">Commander en 1 clic sur WhatsApp</p>
                            </div>
                        </div>

                        <p className="mt-6 text-xs text-white/50 font-body">
                            En continuant, vous acceptez les conditions d'utilisation. Client : gratuit. Vendeurs : rechargez vos crédits via Mobile Money.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
